/**
 * Product mockup used in the hero and the pricing card.
 * While empty, a code-drawn cover in the product identity is shown.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/5FZz8YCoc5u3yKUox22G52/DPS41_-_Principal_-_52_Weeks_of_Speaking.png'

export const PRODUCT_MOCKUP_ALT =
  '52 Weeks of Speaking: a full year of ready-to-run public speaking sessions — six volumes for speaking teachers, coaches and club leaders'

export const PRODUCT_NAME = '52 Weeks of Speaking'

/** Where the pricing button sends the buyer. */
export const CHECKOUT_URL = 'https://52-weeks-of-speaking.impultienda.ar/checkout'
